<template>
    <div class="flow">
        <flowStep v-if="steps[currentStepIndex].StepType == 0" :step="steps[currentStepIndex]"
            :currentStepIndex="currentStepIndex" :nextStepId="nextStepId" :dictionary="dictionary"
            @stepValueChange="handleStepValueChange" @stepChangeForward="handleStepChangeForward"
            @stepChangeBackward="handleStepChangeBackward"></flowStep>
        <flowLocationStep v-if="steps[currentStepIndex].StepType == 1" @toggleSpinner="toggleSpinner"
            :step="steps[currentStepIndex]" :selectedDepartment="selectedDepartment"
            :nextStepId="steps[currentStepIndex].NextStepId" :dictionary="dictionary" @setNextStepId="setNextStepId"
            @stepValueChange="handleStepValueChange" @stepChangeForward="handleStepChangeForward"
            @stepChangeBackward="handleStepChangeBackward" @departmentSelected="handleDepartmentSelected">
        </flowLocationStep>
        <flowResultStep v-if="steps[currentStepIndex].StepType == 2" @toggleSpinner="toggleSpinner"
            :breadcrumbs="breadcrumbs" :step="steps[currentStepIndex]" :guideSteps="resultsGuideSteps"
            :dictionary="dictionary" :department="selectedDepartment" :result="result" :sizeResult="sizeResult"
            @resetFlow="handleResetFlow"></flowResultStep>
        <flowBreadcrumbs v-if="steps[currentStepIndex].StepType != 2" :breadcrumbs="breadcrumbs"
            :currentStep="steps[currentStepIndex]"></flowBreadcrumbs>
    </div>

</template>
<script>
import DepartmentCard from "./components/departmentCard.vue";
import FlowStep from "./components/flowStep.vue";
import FlowLocationStep from "./components/flowLocationStep.vue";
import FlowResultStep from "./components/flowResultStep.vue";
import FlowBreadcrumbs from "./components/flowBreadcrumbs.vue";
export default {
    name: "flow",
    components: {
        DepartmentCard,
        FlowStep,
        FlowLocationStep,
        FlowResultStep,
        FlowBreadcrumbs
    },
    data() {
        return {
            dictionary: [],
            steps: [],
            stepResults: {},
            previousStepIndex: 0,
            nextStepId: 0,
            currentStepIndex: 0,
            resultsGuideSteps: [],
            history: [],
            selectedDepartment: null,
        };
    },
    created() {
        const vm = this;
        vm.steps = JSON.parse(vm.$parent.steps);
        vm.dictionary = JSON.parse(vm.$parent.dictionary);
        vm.resultsGuideSteps = JSON.parse(vm.$parent.resultsGuideSteps);
        vm.clearQueryString();
    },
    methods: {
        handleResetFlow() {
            const vm = this;
            vm.history = [];
            vm.currentStepIndex = 0;
            vm.nextStepId = 0;
            vm.previousStepIndex = 0;
            vm.stepResults = {};
            vm.selectedDepartment = null;
            vm.clearQueryString();
            vm.steps.forEach(step => {
                step.Items.forEach(item => {
                    item.Selected = false;
                    if (item.UserSuppliesValue) {
                        item.Value = 0;
                    }
                });
            });

            this.setHiddenResultFieldInForm(false);
            this.scrollToTopOfComponent();
        },
        handleStepValueChange(stepId, stepItemId, value, nextStepId) {
            const stepIndex = this.steps.indexOf(this.steps.find(x => x.Id == stepId));
            const stepItemIndex = this.steps[stepIndex].Items.indexOf(this.steps[stepIndex].Items.find(x => x.Id == stepItemId));

            if (!this.steps[stepIndex].AllowSelectingMultipleItems) {
                this.steps[stepIndex].Items.forEach(item => {
                    item.Selected = false;
                });
            }

            if (this.steps[stepIndex].Items[stepItemIndex].UserSuppliesValue) {
                if (value > 0) {
                    this.steps[stepIndex].Items[stepItemIndex].Selected = true;
                } else {
                    this.steps[stepIndex].Items[stepItemIndex].Selected = false;
                }
                this.steps[stepIndex].Items[stepItemIndex].Value = value;
            } else {
                this.steps[stepIndex].Items[stepItemIndex].Value = value;
                this.steps[stepIndex].Items[stepItemIndex].Selected = true;
            }

            if (this.steps[stepIndex].Items.filter(item => { return item.Selected == true; }).length > 0) {
                this.nextStepId = nextStepId;
            } else {
                this.nextStepId = 0;
            }
        },
        handleStepChangeForward: function (queryValue = "") {

            const queryValues = [];
            if (queryValue != "") {
                queryValues.push(queryValue);
            } else {
                const stepItems = this.steps[this.currentStepIndex].Items.filter(x => x.Selected == true);
                stepItems.forEach(item => {
                    if (this.steps[this.currentStepIndex].AllowSelectingMultipleItems || item.UserSuppliesValue) {
                        queryValues.push(item.Value + "-" + item.QueryAlias);

                    } else {
                        queryValues.push(item.QueryAlias);
                    }
                });
            }

            this.updateQueryString(this.steps[this.currentStepIndex].QueryAlias, queryValues.toString());

            if (this.nextStepId > 0) {
                this.history.push(this.currentStepIndex);
                this.currentStepIndex = this.steps.indexOf(this.steps.find(x => x.Id == this.nextStepId));
                const selectedItem = this.steps[this.currentStepIndex].Items.find(x => x.Selected);
                if (selectedItem) {
                    this.nextStepId = selectedItem.NextStepId;
                } else {
                    this.nextStepId = 0;
                }
            }

            if (this.steps[this.currentStepIndex].StepType == 2) {
                this.setHiddenResultFieldInForm(true);
            }

            this.scrollToTopOfComponent();
        },
        handleStepChangeBackward: function (nextStepId) {
            const lastHistoryElement = this.history.pop();
            this.updateQueryString(this.steps[this.currentStepIndex].QueryAlias, "", true);

            this.steps[this.currentStepIndex].Items.forEach(item => {
                item.Value = 0;
                item.Selected = false;
            });

            this.currentStepIndex = lastHistoryElement;
            if (nextStepId) {
                this.nextStepId = nextStepId;
            } else {
                if (this.steps[this.currentStepIndex].Items.length > 0) {
                    this.nextStepId = this.steps[this.currentStepIndex].Items.find(x => x.Selected).NextStepId;
                }
            }

            this.scrollToTopOfComponent();

        },
        setNextStepId: function (stepId) {
            this.nextStepId = stepId;
        },
        handleDepartmentSelected: function (department) {
            this.selectedDepartment = department;
            this.scrollToNavigation();
        },
        setHiddenResultFieldInForm: function (value = false) {
            const changeEvent = new Event("change");
            const triggerField = document.querySelector('.isflowresultpage ')?.querySelector('input[type="hidden"]');
            if (triggerField) {
                triggerField.value = value;
                triggerField.dispatchEvent(changeEvent);
            }

            const resultField = document.querySelector('.flowresult')?.querySelector('input[type="hidden"]');
            if (resultField) {
                let resultString = "";
                this.result.forEach(result => {
                    resultString += '\n' + result.Name + ': ';
                    result.Items.forEach(item => {
                        if (result.MultiValue) {
                            resultString += item.Value + ' ';

                        }
                        resultString += item.Name + ', ';
                    });
                });
                resultString += "\nStoerrelse: " + this.sizeResult + 'm2';
                resultField.value = resultString;
                resultField.dispatchEvent(changeEvent);
            }

        },
        scrollToTopOfComponent() {
            const isSmallScreen = window.matchMedia('(max-width: 768px)');
            let componentTop = document.querySelector('.flow').offsetTop;
            if (isSmallScreen.matches) {
                componentTop -= 80;
            } else {
                componentTop -= 249;
            }

            window.scrollTo({
                top: componentTop,
                behavior: 'smooth',
            });
        },
        scrollToNavigation() {
            const isSmallScreen = window.matchMedia('(max-width: 768px)');
            let navigationTop = document.querySelector('.flow-step__navigation').offsetTop - 150; //Subtracting a lot more here to better position the nav
            if (isSmallScreen.matches) {
                window.scrollTo({
                    top: navigationTop,
                    behavior: 'smooth',
                });
            }
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
        updateQueryString: function (name, value, remove = false) {
            if ('URLSearchParams' in window) {
                var searchParams = new URLSearchParams(window.location.search);
                if (!remove) {
                    searchParams.set(name, value);

                } else {
                    searchParams.delete(name);
                }
                const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
                window.history.pushState({ path: updatedUrl }, '', updatedUrl);
            }
        },
        clearQueryString: function () {
            const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            window.history.pushState({ path: updatedUrl }, '', updatedUrl);

        }
    },
    computed: {
        breadcrumbs: function () {
            return this.steps.map(x => x.BreadcrumbText).filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
        },
        sizeResult: function () {
            const vm = this;
            let total = 0;
            for (const step of vm.steps) {
                for (const item of step.Items) {
                    if (typeof item.Selected == 'undefined' || !item.Selected) {
                        continue;
                    }
                    if (item.Value > 0) {
                        if (item.DivideWithFactor) {
                            total += item.Value / item.Factor;
                        } else {
                            total += item.Value * item.Factor;
                        }
                    }
                }

            }

            return total;
        },
        result: function () {
            const vm = this;

            const resultArray = [];

            for (const step of vm.steps) {
                if (!step.Items.some(x => x.Selected)) continue;

                let stepResult = {
                    Name: step.Label,
                    MultiValue: step.AllowSelectingMultipleItems,
                    Items: []
                }
                for (const stepItem of step.Items.filter(item => item.Selected == true)) {
                    let itemResult = {
                        Name: stepItem.Label,
                        Value: stepItem.Value,
                        Selected: stepItem.Selected
                    }
                    stepResult.Items.push(itemResult);

                }
                resultArray.push(stepResult);
            }

            if (vm.selectedDepartment != null) {
                const locationsStep = vm.steps.find(x => x.StepType == 1);
                let stepResult = {
                    Name: locationsStep.Label,
                    MultiValue: false,
                    Items: [{
                        Name: vm.selectedDepartment.Zip,
                        Value: null,
                        Selected: true
                    }]
                }
                resultArray.push(stepResult);
            }
            return resultArray;
        }
    }
};
</script>
